import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

Sentry.init({
  dsn: environment.sentry.dsn,
  integrations: [Sentry.browserTracingIntegration(), Sentry.httpClientIntegration()],
  tracesSampleRate: 0.1,
  environment: environment.name,
  debug: environment.sentry.debug,
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
